// DO NOT EDIT THIS IS AN AUTOGENERATED FILE;
import * as React from 'react'

interface IconProps {
  color?: string
  size?: string | number
}

const SvgUserCheck = ({color = 'currentColor', size = 20}: IconProps) => (
  <svg
    viewBox="0 0 20 20"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    height={size}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.758 3.5a2.499 2.499 0 1 0 0 4.997 2.499 2.499 0 0 0 0-4.998ZM5.76 5.997a3.998 3.998 0 1 1 7.997 0 3.998 3.998 0 0 1-7.997 0Zm4.248 6.747c-3.744 0-5.374 1.583-6.11 2.826-.139.233-.103.418.014.573.138.183.422.35.798.35h5.298a.75.75 0 0 1 0 1.498H4.712c-.803 0-1.549-.353-1.995-.944-.467-.617-.571-1.46-.109-2.24 1.007-1.7 3.128-3.562 7.401-3.562a.75.75 0 1 1 0 1.499Zm7.605.439a.75.75 0 0 0-1.216-.878l-2.683 3.715-.63-.757a.75.75 0 1 0-1.153.96l1.25 1.499a.75.75 0 0 0 1.183-.041l3.249-4.498Z"
    />
  </svg>
)

export default SvgUserCheck
